module.exports = __webpack_public_path__ + "img/Imaginative Mind.13273b4e.svg";